import _ from 'lodash';

const processStrategy = (paymentMethod) => {
  const relations = {};
  const omit = [];
  return { ..._.omit(paymentMethod, omit), ..._.pickBy(relations, _.identity) };
};

export default {
  key: 'paymentMethod',
  definition: {},
  processStrategy,
};
